import gql from "graphql-tag";

export default gql`
  query getCustomFilter($query: QueryInput, $offset: OffsetInput) {
    getCustomFilter(query: $query, offset: $offset) {
      __typename
      id
      user_id
      type
      name
      definition
    }
  }
`;
